import axios from 'axios'

export function request(config) {
    const instance=axios.create({
        baseURL:'http://120.77.180.242:8080',
        // baseURL:'http://152.136.185.210:7878/api/m5',
        withCredentials : true,
        timeout:5000
    })
    instance.interceptors.response.use(res=>{
        return res
    },error => {
        console.log(error)
    })
    return instance(config)
}